import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./EventCalendar.scss";
import PropertyService from "../../services/PropertyService";
import DailyLogService from "../../services/DailyLogService";
import Select from "react-select";
import LeftArrow from "../../assets/images/left-arrow.svg";
import deleteicon from "../../assets/images/delete-gray.svg";
import EditpenIcon from "./../../assets/images/edit-pen-icon.svg";
import Moment from "moment";
import PropertySelection from "../dashboard/PropertySelection";
import InputMask from "react-input-mask";

let errorLangMessages = {
  timeMessage: "Please enter a valid time in 12-hour format (e.g., 01:30 AM).",
  property: "The property field is required.",
  eventTitle: "The event title field is required.",
  endTimeGtSt: "End time must be after start time.",
  recurrenceEndDate: "Please select an end date for the recurring event.",
  weekDayRecurrence: "Please select a weekday for weekly recurrence.",
  startDateRecurrence: "Start date is required for recurring events.",
  startDate: "The start date field is required.",
  endDate: "The end date field is required.",
  endDateGtStartDate: "End date must be after the start date.",
  startDateAlert: "Start date must be today or later.",
  recurrenceEndDateGtStartDate:
    "Recurrence end date must be after the start date.",
};
const defaultDeleteMessage = "Are you sure you want to delete this event?";
class DailyLogEvent extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    const currentTime = Moment(now).format("hh:mm A");
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
    const endTime = Moment(oneHourLater).format("hh:mm A");
    this.state = {
      properties: [],
      selectedProperty: null,
      events: [],
      view: "month",
      showEventModal: false,
      showDayEventsModal: false,
      selectedDayEvents: [],
      newEvent: {
        property_slug: "",
        title: "",
        scheduleType: "3",
        recurrence: false,
        recurrenceType: "daily",
        recurrenceEndDate: "",
        weekday: "Monday",
        startDate: now,
        endDate: now,
        startTime: currentTime,
        endTime: endTime,
        visibility: "immediate",
        remarks: "",
      },
      currentDate: new Date(),
      loading: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      calendarData: {
        month: {
          month_name: "",
          start_date: "",
          end_date: "",
          days: [],
        },
        week: {
          week_number: 0,
          start_date: "",
          end_date: "",
          days: [],
        },
        day: {
          date: "",
          weekday: "",
          events: [],
        },
        events: [],
      },
      editingEventSlug: null,
      deleteEventMessage: defaultDeleteMessage,
      showDeleteConfirm: false,
      eventToDeleteSlug: null,
      scheduleType: global.scheduleType,
      weekDay: global.weekDay,
      visibility: global.visibility,
      monthViewCurrentDate: new Date(),
      errors: {},
      recurrenceTypes: [
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
        { value: "monthly", label: "Monthly" },
        { value: "quarterly", label: "Quarterly" },
        { value: "biannually", label: "Bi-annually" },
        { value: "yearly", label: "Yearly" },
      ],
      showPicker: false,
      pickerMode: "month", // month | year
      selectedDate: new Date(),
    };
    this.getPropertySlug = this.getPropertySlug.bind(this);
    this.pickerRef = React.createRef();

    this.expandedDays = {};
  }

  componentDidMount() {
    this.getPropertyList().then(() => {
      this.fetchCalendarData();
      this.setSelectedPropertyFromGlobal();
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (
      this.pickerRef.current &&
      !this.pickerRef.current.contains(event.target)
    ) {
      this.setState({ showPicker: false });
    }
  };
  // Date utility functions
  parseDateWithoutTimezone = (dateString) => {
    if (!dateString) return null;

    if (dateString instanceof Date) return dateString;

    if (typeof dateString === "string" && dateString.includes("-")) {
      const [year, month, day] = dateString.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    return new Date(dateString);
  };

  formatDateForDisplay = (date) => {
    if (!date) return "";
    const d = this.parseDateWithoutTimezone(date);
    return d.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      weekday: "long",
    });
  };

  formatDateForAPI = (date) => {
    if (!date) return "";
    const d = this.parseDateWithoutTimezone(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  setSelectedPropertyFromGlobal() {
    let selectedProperty = null;

    if (localStorage.getItem("activePropertyCount") == 1) {
      selectedProperty = localStorage.getItem("singlePorpertySlug") || "";
    } else if (localStorage.getItem("outSidePorpertySlug")) {
      selectedProperty = localStorage.getItem("outSidePorpertySlug") || "";
    }

    if (selectedProperty) {
      const selectedPropertyObj = this.state.properties.find(
        (property) => property.value === selectedProperty,
      );
      if (selectedPropertyObj) {
        this.setState({ selectedProperty: selectedPropertyObj });
      }
    }
  }

  formatTo12HourTime = (time) => {
    const formattedTime = Moment(time, "HH:mm").format("hh:mm A");
    return formattedTime;
  };

  fetchCalendarData = async () => {
    const { currentDate } = this.state;
    this.setState({ loading: true });

    try {
      let propertySlug = "";

      if (localStorage.getItem("activePropertyCount") == 1) {
        propertySlug = localStorage.getItem("singlePorpertySlug") || "";
      } else if (
        localStorage.getItem("outSidePorpertySlug") !== undefined &&
        localStorage.getItem("outSidePorpertySlug") !== null &&
        localStorage.getItem("outSidePorpertySlug") !== ""
      ) {
        propertySlug = localStorage.getItem("outSidePorpertySlug") || "";
      } else if (this.state.selectedProperty?.value) {
        propertySlug = this.state.selectedProperty.value;
      }

      // Use UTC date without timezone to avoid date shifting
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const dateString = `${year}-${month}-${day}`;

      const params = {
        date: dateString,
      };

      if (propertySlug) {
        params.property_slug = propertySlug;
      }

      const queryString = new URLSearchParams(params).toString();
      const res = await DailyLogService.getEventList(queryString);
      this.setSelectedPropertyFromGlobal();
      if (global.successStatus.includes(res.status)) {
        this.setState({
          calendarData: {
            month: res.data.month || this.state.calendarData.month,
            week: res.data.week || this.state.calendarData.week,
            day: res.data.day || this.state.calendarData.day,
            events: res.data.events || [],
          },
          loading: false,
        });
      } else {
        throw res;
      }
    } catch (error) {
      console.error("Error fetching calendar data:", error);
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage:
          error?.data?.message || "Failed to fetch calendar data",
      });
    }
  };

  getPropertySlug(selectedProperty) {
    this.setState({
      selectedProperty: selectedProperty,
      property_slug: selectedProperty?.value || "",
    });

    setTimeout(() => {
      var formattedDataProperty = JSON.parse(
        localStorage.getItem("formattedDataDailyLog"),
      );
      this.setState({ formattedData: formattedDataProperty });
    }, 1000);

    setTimeout(() => {
      this.fetchCalendarData();
      this.getProperty();
    }, 200);

    this.setState({
      unit_number: "",
      module_search: [],
      is_search: 0,
    });
  }

  async getProperty(queryString = "") {
    var propertyList = [];
    var propertyListData = [];
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : ""),
    );
    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
    }
    if (propertyList.length > 0) {
      propertyList.forEach((item) => {
        propertyListData.push({
          label: item.property_name,
          value: item.slug,
        });
      });
    }
    this.setState({
      propertyList: propertyListData,
    });
  }

  getScheduleTypeName = (type) => {
    switch (parseInt(type)) {
      case 1:
        return "Daily";
      case 2:
        return "Weekly";
      case 3:
        return "Between Dates";
      case 4:
        return "Monthly";
      case 5:
        return "Quarterly";
      case 6:
        return "Bi-annually";
      case 7:
        return "Yearly";
      default:
        return "Event";
    }
  };

  formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  async getPropertyList(queryString = "") {
    this.setState({ loading: true });
    try {
      const res = await PropertyService.getPropertyList(
        "is_dropdown=1" + (queryString ? "&" + queryString : ""),
      );

      if (global.successStatus.includes(res.status)) {
        const propertyList = res.data || [];
        const propertyListData = propertyList.map((item) => ({
          label: item.property_name,
          value: item.slug,
        }));

        const selectedProperty =
          propertyList.length === 1 ? propertyList[0].slug : null;

        this.setState({
          properties: propertyListData,
          selectedProperty,
          loading: false,
          newEvent: {
            ...this.state.newEvent,
            property_slug: selectedProperty || "",
          },
        });
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
      this.setState({ loading: false });
    }
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (this.state.errors[name]) {
      this.setState((prevState) => ({
        errors: { ...prevState.errors, [name]: null },
      }));
    }

    if (name === "recurrence") {
      this.setState((prevState) => ({
        newEvent: {
          ...prevState.newEvent,
          [name]: checked,
          scheduleType: checked ? "1" : "3",
        },
      }));
    } else {
      this.setState((prevState) => ({
        newEvent: {
          ...prevState.newEvent,
          [name]: type === "checkbox" ? checked : value,
        },
      }));
    }
  };

  handleTimeChange = (e, fieldName) => {
    let value = e.target.value.trim().toUpperCase();
    const timePattern = /^(0?[1-9]|1[0-2]):([0-5][0-9])\s([AP][M])$/;

    if (!timePattern.test(value)) {
      this.setState((prevState) => ({
        newEvent: {
          ...prevState.newEvent,
          [fieldName]: value,
        },
      }));
      if (fieldName === "startTime") {
        this.setState((prevState) => ({
          errors: {
            ...prevState.errors,
            start_time_error: errorLangMessages.timeMessage,
          },
        }));
      }
      if (fieldName === "endTime") {
        this.setState((prevState) => ({
          errors: {
            ...prevState.errors,
            end_time_error: errorLangMessages.timeMessage,
          },
        }));
      }
      return;
    }

    this.setState((prevState) => ({
      newEvent: {
        ...prevState.newEvent,
        [fieldName]: value,
      },
      errors: {
        ...prevState.errors,
        ...(fieldName === "startTime" && { start_time_error: null }),
        ...(fieldName === "endTime" && { end_time_error: null }),
      },
    }));
  };

  handleDateChange = (date, fieldName) => {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        startDate: null,
        endDate: null,
        recurrenceEndDate: null,
      },
    }));

    if (this.state.errors[fieldName]) {
      this.setState((prevState) => ({
        errors: { ...prevState.errors, [fieldName]: null },
      }));
    }
    this.setState((prevState) => ({
      newEvent: {
        ...prevState.newEvent,
        [fieldName]: date,
      },
    }));
  };

  handleChangeProperty = (value) => {
    if (this.state.errors.property) {
      this.setState((prevState) => ({
        errors: { ...prevState.errors, property: null },
      }));
    }
    const property_slug = value ? value.value : null;
    this.setState({
      selectedProperty: property_slug,
      newEvent: {
        ...this.state.newEvent,
        property_slug,
      },
    });
  };

  handleChangeScheduleType = (value) => {
    const scheduleType = value ? value.value : null;
    this.setState({
      newEvent: {
        ...this.state.newEvent,
        scheduleType,
      },
    });
  };

  handleChangeRecurrenceType = (value) => {
    const recurrenceType = value ? value.value : null;
    this.setState({
      newEvent: {
        ...this.state.newEvent,
        recurrenceType,
      },
    });
  };

  handleChangeWeekday = (value) => {
    const weekday = value ? value.value : null;
    this.setState({
      newEvent: {
        ...this.state.newEvent,
        weekday,
      },
    });
  };

  handleChangeVisibility = (value) => {
    const visibility = value ? value.value : null;
    this.setState({
      newEvent: {
        ...this.state.newEvent,
        visibility,
      },
    });
  };

  convertTo24HourFormat = (time12h) => {
    if (!time12h) return "";

    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  };

  addEvent = async () => {
    const { newEvent, selectedProperty } = this.state;
    this.setState({ loading: true });

    try {
      let schedule_type;
      if (newEvent.recurrence) {
        switch (newEvent.recurrenceType) {
          case "daily":
            schedule_type = 1;
            break;
          case "weekly":
            schedule_type = 2;
            break;
          case "monthly":
            schedule_type = 4;
            break;
          case "quarterly":
            schedule_type = 5;
            break;
          case "biannually":
            schedule_type = 6;
            break;
          case "yearly":
            schedule_type = 7;
            break;
          default:
            schedule_type = 1;
        }
      } else {
        schedule_type = 3;
      }

      const eventData = {
        title: newEvent.title,
        property_slug:
          typeof selectedProperty === "object" && selectedProperty !== null
            ? selectedProperty.value
            : selectedProperty,
        schedule_type: schedule_type,
        recurrence: newEvent.recurrence,
        recurrence_end_date:
          newEvent.recurrence && newEvent.recurrenceEndDate
            ? this.formatDateForAPI(newEvent.recurrenceEndDate)
            : null,
        weekday: newEvent.weekday,
        start_date: newEvent.startDate
          ? this.formatDateForAPI(newEvent.startDate)
          : null,
        end_date: newEvent.endDate
          ? this.formatDateForAPI(newEvent.endDate)
          : null,
        start_time: this.convertTo24HourFormat(newEvent.startTime),
        end_time: this.convertTo24HourFormat(newEvent.endTime),
        visibility: newEvent.visibility,
        remarks: newEvent.remarks,
      };

      const res = await DailyLogService.createDailyLogEvent(eventData);

      if (global.successStatus.includes(res.status)) {
        this.setState(
          {
            showEventModal: false,
            newEvent: {
              property_slug: "",
              title: "",
              scheduleType: "3",
              recurrence: false,
              recurrenceType: "daily",
              recurrenceEndDate: new Date(),
              weekday: "Monday",
              startDate: new Date(),
              endDate: new Date(),
              startTime: Moment(new Date()).format("hh:mm A"),
              endTime: Moment(new Date().getTime() + 60 * 60 * 1000).format(
                "hh:mm A",
              ),
              visibility: "immediate",
              remarks: "",
            },
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message || "Event created successfully",
          },
          this.fetchCalendarData,
        );

        setTimeout(() => {
          this.setState({ showAlertModal: false });
        }, global.alert_close_time);
      } else {
        throw res;
      }
    } catch (error) {
      console.error("Error adding event:", error);
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error?.data?.message || "Failed to create event",
      });
    }
  };

  handleEventClick = (event) => {
    this.setState({
      selectedDayEvents: [event],
      showDayEventsModal: true,
    });
  };

  handleEditEvent = (event) => {
    const isRecurring = event.recurrence;
    let recurrenceType = "daily";

    if (isRecurring) {
      switch (parseInt(event.schedule_type)) {
        case 1:
          recurrenceType = "daily";
          break;
        case 2:
          recurrenceType = "weekly";
          break;
        case 4:
          recurrenceType = "monthly";
          break;
        case 5:
          recurrenceType = "quarterly";
          break;
        case 6:
          recurrenceType = "biannually";
          break;
        case 7:
          recurrenceType = "yearly";
          break;
        default:
          recurrenceType = "daily";
      }
    }

    const convertTo12HourFormat = (time24h) => {
      if (!time24h) return "09:00 AM";
      let [hours, minutes] = time24h.split(":");
      hours = parseInt(hours, 10);
      const ampm = hours >= 12 ? "PM" : "AM";
      const hour12 = hours % 12 || 12;
      return `${hour12.toString().padStart(2, "0")}:${minutes.padStart(2, "0")} ${ampm}`;
    };

    this.setState({
      showEventModal: true,
      editingEventSlug: event.slug,
      selectedProperty: event.property?.slug || null,
      newEvent: {
        property_slug: event.property?.slug || "",
        title: event.title,
        scheduleType: isRecurring ? "1" : "3",
        recurrence: isRecurring,
        recurrenceType: recurrenceType,
        recurrenceEndDate: event.recurrence_end_date
          ? this.parseDateWithoutTimezone(event.recurrence_end_date)
          : null,
        weekday: event.weekday || "Monday",
        startDate: event.start_date
          ? this.parseDateWithoutTimezone(event.start_date)
          : null,
        endDate: event.end_date
          ? this.parseDateWithoutTimezone(event.end_date)
          : null,
        startTime: convertTo12HourFormat(event.start_time),
        endTime: convertTo12HourFormat(event.end_time),
        visibility: event.visibility,
        remarks: event.remarks || "",
      },
    });
  };

  updateEvent = async () => {
    const { newEvent, editingEventSlug, selectedProperty } = this.state;
    this.setState({ loading: true });

    try {
      let schedule_type;
      if (newEvent.recurrence) {
        switch (newEvent.recurrenceType) {
          case "daily":
            schedule_type = 1;
            break;
          case "weekly":
            schedule_type = 2;
            break;
          case "monthly":
            schedule_type = 4;
            break;
          case "quarterly":
            schedule_type = 5;
            break;
          case "biannually":
            schedule_type = 6;
            break;
          case "yearly":
            schedule_type = 7;
            break;
          default:
            schedule_type = 1;
        }
      } else {
        schedule_type = 3;
      }

      const eventData = {
        title: newEvent.title,
        property_slug: selectedProperty,
        schedule_type: schedule_type,
        recurrence: newEvent.recurrence,
        recurrence_end_date:
          newEvent.recurrence && newEvent.recurrenceEndDate
            ? this.formatDateForAPI(newEvent.recurrenceEndDate)
            : null,
        weekday: newEvent.weekday,
        start_date: newEvent.startDate
          ? this.formatDateForAPI(newEvent.startDate)
          : null,
        end_date: newEvent.endDate
          ? this.formatDateForAPI(newEvent.endDate)
          : null,
        start_time: this.convertTo24HourFormat(newEvent.startTime),
        end_time: this.convertTo24HourFormat(newEvent.endTime),
        visibility: newEvent.visibility,
        remarks: newEvent.remarks,
      };

      const res = await DailyLogService.UpdateDailyLogEvent(
        editingEventSlug,
        eventData,
      );

      if (global.successStatus.includes(res.status)) {
        this.setState(
          {
            showEventModal: false,
            editingEventSlug: null,
            newEvent: {
              property_slug: this.state.selectedProperty || "",
              title: "",
              scheduleType: "3",
              recurrence: false,
              recurrenceType: "daily",
              recurrenceEndDate: new Date(),
              weekday: "Monday",
              startDate: new Date(),
              endDate: new Date(),
              startTime: Moment(new Date()).format("hh:mm A"),
              endTime: Moment(new Date().getTime() + 60 * 60 * 1000).format(
                "hh:mm A",
              ),
              visibility: "immediate",
              remarks: "",
            },
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message || "Event updated successfully",
          },
          this.fetchCalendarData,
        );
      } else {
        throw res;
      }
    } catch (error) {
      console.error("Error updating event:", error);
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error?.data?.message || "Failed to update event",
      });
    }
  };

  handleSaveEvent = () => {
    if (!this.validateForm()) {
      return;
    } else {
      this.clearErrors();
    }
    if (this.state.editingEventSlug) {
      this.updateEvent();
    } else {
      this.addEvent();
    }
  };

  handleDeleteClick = (event) => {
    if (event?.recurrence) {
      this.setState({
        deleteEventMessage:
          "Are you sure you want to delete the <b>recurring</b> event '" +
          event?.title +
          "'? This will permanently remove all past and future <b>occurrences of this</b> event.",
      });
    }
    this.setState({
      showDeleteConfirm: true,
      eventToDeleteSlug: event.slug,
    });
  };

  confirmDelete = async () => {
    const { eventToDeleteSlug, selectedProperty } = this.state;
    this.setState({ loading: true });
    this.setState({
      deleteEventMessage: defaultDeleteMessage,
    });

    try {
      const res = await DailyLogService.deleteDailyLogEvent(eventToDeleteSlug, {
        property_slug: selectedProperty,
      });

      if (global.successStatus.includes(res.status)) {
        this.setState(
          {
            showDeleteConfirm: false,
            eventToDeleteSlug: null,
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message || "Event deleted successfully",
          },
          this.fetchCalendarData,
        );
      } else {
        throw res;
      }
    } catch (error) {
      console.error("Error deleting event:", error);
      this.setState({
        loading: false,
        showDeleteConfirm: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error?.data?.message || "Failed to delete event",
      });
    }
  };

  cancelDelete = () => {
    this.setState({
      deleteEventMessage: defaultDeleteMessage,
    });
    this.setState({
      showDeleteConfirm: false,
      eventToDeleteSlug: null,
    });
  };

  toggleEventModal = () => {
    const now = new Date();
    const currentTime = Moment(now).format("hh:mm A");
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
    const endTime = Moment(oneHourLater).format("hh:mm A");
    this.clearErrors();
    this.setState((prevState) => ({
      showEventModal: !prevState.showEventModal,
      editingEventSlug: prevState.showEventModal
        ? null
        : prevState.editingEventSlug,
      newEvent: {
        ...(prevState.showEventModal
          ? {
              property_slug: prevState.selectedProperty || "",
              title: "",
              scheduleType: "3",
              recurrence: false,
              recurrenceType: "daily",
              recurrenceEndDate: now,
              weekday: "Monday",
              startDate: now,
              endDate: now,
              startTime: currentTime,
              endTime: endTime,
              visibility: "immediate",
              remarks: "",
            }
          : prevState.newEvent),
        property_slug: prevState.selectedProperty || "",
      },
    }));
  };

  changeView = (view) => {
    this.setState(
      {
        view,
        currentDate: new Date(),
      },
      this.fetchCalendarData,
    );
  };

  navigateDate = (direction, unit = null) => {
    const { currentDate, view } = this.state;
    const newDate = new Date(currentDate);
    const activeUnit = unit || view;

    switch (activeUnit) {
      case "day":
        newDate.setDate(newDate.getDate() + (direction === "next" ? 1 : -1));
        break;
      case "week":
        newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
        break;
      case "month":
        newDate.setMonth(newDate.getMonth() + (direction === "next" ? 1 : -1));
        break;
      default:
        break;
    }

    this.setState({ currentDate: newDate }, this.fetchCalendarData);
  };
  navigateSelectedDate = (selecteddate) => {
    this.setState({ currentDate: selecteddate }, this.fetchCalendarData);
  };

  handleDayClick = (date) => {
    const { calendarData } = this.state;

    const clickedDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    );

    const dayEvents = calendarData.events.filter((event) => {
      const eventStart = event.start_date
        ? this.parseDateWithoutTimezone(event.start_date)
        : null;
      const eventEnd = event.end_date
        ? this.parseDateWithoutTimezone(event.end_date)
        : null;
      const recurrenceEnd = event.recurrence_end_date
        ? this.parseDateWithoutTimezone(event.recurrence_end_date)
        : null;

      const normalizedEventStart = eventStart
        ? new Date(
            eventStart.getFullYear(),
            eventStart.getMonth(),
            eventStart.getDate(),
          )
        : null;
      const normalizedEventEnd = eventEnd
        ? new Date(
            eventEnd.getFullYear(),
            eventEnd.getMonth(),
            eventEnd.getDate(),
          )
        : null;
      const normalizedRecurrenceEnd = recurrenceEnd
        ? new Date(
            recurrenceEnd.getFullYear(),
            recurrenceEnd.getMonth(),
            recurrenceEnd.getDate(),
          )
        : null;

      switch (parseInt(event.schedule_type)) {
        case 1: // Daily
          return (
            event.recurrence &&
            clickedDate >= normalizedEventStart &&
            (!normalizedRecurrenceEnd || clickedDate <= normalizedRecurrenceEnd)
          );

        case 2: // Weekly
          return (
            event.recurrence &&
            event.weekday ===
              clickedDate.toLocaleDateString("en-US", { weekday: "long" }) &&
            (!normalizedRecurrenceEnd || clickedDate <= normalizedRecurrenceEnd)
          );

        case 3: // Between dates
          return (
            normalizedEventStart &&
            normalizedEventEnd &&
            clickedDate >= normalizedEventStart &&
            clickedDate <= normalizedEventEnd
          );

        case 4: // Monthly
          return (
            event.recurrence &&
            normalizedEventStart &&
            clickedDate.getDate() === normalizedEventStart.getDate() &&
            (!normalizedRecurrenceEnd || clickedDate <= normalizedRecurrenceEnd)
          );

        case 5: // Quarterly
          return (
            event.recurrence &&
            normalizedEventStart &&
            clickedDate.getDate() === normalizedEventStart.getDate() &&
            (!normalizedRecurrenceEnd || clickedDate <= normalizedRecurrenceEnd)
          );

        case 6: // Bi-annually
          return (
            event.recurrence &&
            normalizedEventStart &&
            clickedDate.getDate() === normalizedEventStart.getDate() &&
            (!normalizedRecurrenceEnd || clickedDate <= normalizedRecurrenceEnd)
          );

        case 7: // Yearly
          return (
            event.recurrence &&
            normalizedEventStart &&
            clickedDate.getDate() === normalizedEventStart.getDate() &&
            (!normalizedRecurrenceEnd || clickedDate <= normalizedRecurrenceEnd)
          );
        default: // Single day
          return (
            normalizedEventStart &&
            normalizedEventStart.getTime() === clickedDate.getTime()
          );
      }
    });

    this.setState({
      selectedDayEvents: dayEvents,
      showDayEventsModal: dayEvents.length > 0,
      monthViewCurrentDate: date,
    });
  };

  getEventColor = (event) => {
    switch (parseInt(event.schedule_type)) {
      case 1:
        return "#00ab271a";
      case 2:
        return "#3250461a";
      case 3:
        return "#0069c026";
      case 4:
        return "#9c27b01a";
      case 5:
        return "#d59a111a";
      case 6:
        return "#3fb9b31a";
      case 7:
        return "#8a6fe01a";
      default:
        return "#D3D3D3";
    }
  };

  toggleDayExpansion = (date) => {
    this.expandedDays[date] = !this.expandedDays[date];
    this.forceUpdate();
  };

  renderDayView() {
    const { calendarData, loading } = this.state;

    if (loading) return <div className="loading-indicator">Loading...</div>;

    const currentDate = calendarData.day.date
      ? this.parseDateWithoutTimezone(calendarData.day.date)
      : new Date();

    const currentSystemDate = new Date();
    const isToday =
      currentSystemDate.toDateString() === currentDate.toDateString();
    const formattedDate = this.formatDateForDisplay(currentDate);

    return (
      <div className="day-view">
        <div className="day-view-navigation">
          <div className="day-navigation">
            <button onClick={() => this.navigateDate("prev", "day")}>
              <img src={LeftArrow} />
            </button>
            <h3
              className="mb-0"
              onClick={() =>
                this.setState({ showPicker: true, pickerMode: "day" })
              }
            >
              {isToday ? "Today - " : ""} {formattedDate || ""}
            </h3>
            {this.state.showPicker && this.rendarcalendar()}
            <button
              className="next-btn"
              onClick={() => this.navigateDate("next", "day")}
            >
              <img src={LeftArrow} className="rotate-180" />
            </button>
          </div>
        </div>
        <div className="events-list">
          {calendarData.day.events && calendarData.day.events.length > 0 ? (
            calendarData.day.events.map((event) => (
              <div
                key={event.slug}
                className="event-item"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleEventClick(event);
                }}
              >
                <strong className="eventPropertyName">
                  {event?.property?.property_name}
                </strong>
                {/* <div className="event-time-range">
                  {this.formatTime(event.start_time)} -{" "}
                  {this.formatTime(event.end_time)}
                </div> */}
                <span className="event-time">
                  <span className="event-part">
                    {Moment(
                      this.parseDateWithoutTimezone(event.start_date),
                    ).format("MMM DD")}
                    , {this.formatTime(event.start_time)}
                  </span>
                  <span className="event-separator"> to </span>
                  <span className="event-part">
                    {Moment(
                      this.parseDateWithoutTimezone(event.end_date),
                    ).format("MMM DD")}
                    , {this.formatTime(event.end_time)}
                  </span>
                </span>{" "}
                <div className="event-details">
                  <strong>{event.title}</strong>
                  <p>{event.remarks}</p>
                  <div className="event-meta">
                    <span
                      className="event-type"
                      style={{ backgroundColor: this.getEventColor(event) }}
                    >
                      {this.getScheduleTypeName(event.schedule_type)}
                    </span>
                    {event.schedule_type == 2 && (
                      <span>Every {event.weekday}</span>
                    )}
                    {event.schedule_type == 4 && (
                      <span>
                        Monthly on day:{" "}
                        {Moment(
                          this.parseDateWithoutTimezone(event.start_date),
                        ).format("DD MMM, YY")}
                      </span>
                    )}
                    {event.recurrence_end_date && (
                      <span className="until-year-text">
                        Until:{" "}
                        {Moment(
                          this.parseDateWithoutTimezone(
                            event.recurrence_end_date,
                          ),
                        ).format("DD MMM, YY")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="event-actions">
                  {global.userPermissions.checkPermission(
                    "calendar-update",
                  ) && (
                    <button
                      className="edit-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleEditEvent(event);
                      }}
                    >
                      <img src={EditpenIcon} />
                    </button>
                  )}
                  {global.userPermissions.checkPermission(
                    "calendar-delete",
                  ) && (
                    <button
                      className="delete-btn-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleDeleteClick(event);
                      }}
                    >
                      <img src={deleteicon} />
                    </button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>No events scheduled for this day.</p>
          )}
        </div>
      </div>
    );
  }

  renderWeekView() {
    const { calendarData, loading } = this.state;

    if (loading) return <div className="loading-indicator">Loading...</div>;

    const weekStart = this.parseDateWithoutTimezone(
      calendarData.week.start_date,
    );
    const weekEnd = this.parseDateWithoutTimezone(calendarData.week.end_date);
    const weekRange = `${weekStart.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    })} - ${weekEnd.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })}`;

    return (
      <div className="zoho-style-week-view">
        <div className="day-view-navigation week-header">
          <div className="day-navigation">
            <button onClick={() => this.navigateDate("prev", "week")}>
              <img src={LeftArrow} alt="" />
            </button>
            <h3
              className="mb-0"
              onClick={() =>
                this.setState({ showPicker: true, pickerMode: "day" })
              }
            >
              Week {calendarData.week.week_number} ({weekRange})
            </h3>
            {this.state.showPicker && this.rendarcalendar()}
            <button
              className="next-btn"
              onClick={() => this.navigateDate("next", "week")}
            >
              <img src={LeftArrow} alt="" />
            </button>
          </div>
        </div>

        <div className="week-grid">
          {calendarData.week.days && calendarData.week.days.length > 0 ? (
            calendarData.week.days.map((day) => {
              const date = this.parseDateWithoutTimezone(day.date);
              const isToday = date.toDateString() === new Date().toDateString();
              const isExpanded = this.expandedDays[day.date];
              const eventsToShow = isExpanded
                ? day.events
                : day.events.slice(0, 4);

              return (
                <div
                  key={day.date}
                  className={`week-day ${isToday ? "today" : ""}`}
                >
                  <div className="week-day-header">
                    <div className="weekday-name">{day.weekday}</div>
                    <div className="day-number">{date.getDate()}</div>
                  </div>
                  <div className="week-day-events">
                    {eventsToShow.map((event, index) => {
                      const startTime = new Date(
                        `1970-01-01T${event.start_time}`,
                      );
                      const endTime = new Date(`1970-01-01T${event.end_time}`);
                      const durationHours =
                        (endTime - startTime) / (1000 * 60 * 60);
                      const isLongEvent = durationHours >= 1;

                      return (
                        <div
                          key={`${event.slug}-${index}`}
                          className={`week-event event-item ${isLongEvent ? "long-event" : ""}`}
                          style={{
                            backgroundColor: this.getEventColor(event),
                            borderLeft: `4px solid ${this.getEventColor(event)}`,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleEventClick(event);
                          }}
                        >
                          {/* <div className="event-time-range">
                            {this.formatTime(event.start_time)} -{" "}
                            {this.formatTime(event.end_time)}
                          </div> */}
                          <span className="event-time">
                            <span className="event-part">
                              {Moment(
                                this.parseDateWithoutTimezone(event.start_date),
                              ).format("MMM DD")}
                              , {this.formatTime(event.start_time)}
                            </span>
                            <span className="event-separator"> to </span>
                            <span className="event-part">
                              {Moment(
                                this.parseDateWithoutTimezone(event.end_date),
                              ).format("MMM DD")}
                              , {this.formatTime(event.end_time)}
                            </span>
                          </span>{" "}
                          <div className="event-title">{event.title}</div>
                          {event.schedule_type === "2" && (
                            <div className="event-recurrence">
                              <span className="recurrence-icon">↻</span> Weekly
                            </div>
                          )}
                          {event.schedule_type === "4" && (
                            <div className="event-recurrence">
                              <span className="recurrence-icon">↻</span> Monthly
                            </div>
                          )}
                          {event.schedule_type === "3" && (
                            <div className="event-recurrence">
                              <span className="recurrence-icon">↔</span>{" "}
                              Multi-day
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {day.events.length > 4 && !isExpanded && (
                      <div
                        className="more-events"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.toggleDayExpansion(day.date);
                        }}
                      >
                        +{day.events.length - 4} more events
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-events">No events scheduled for this week</div>
          )}
        </div>
      </div>
    );
  }

  renderMonthView() {
    const { calendarData, loading } = this.state;
    if (loading) return <div className="loading-indicator">Loading...</div>;

    return (
      <div className="month-view">
        <div className="day-view-navigation month-header">
          <div className="day-navigation">
            <button onClick={() => this.navigateDate("prev", "month")}>
              <img src={LeftArrow} />
            </button>
            <h3
              className="mb-0 cursor-pointer"
              onClick={() =>
                this.setState({ showPicker: true, pickerMode: "month" })
              }
            >
              {calendarData.month.month_name || "Loading..."}
            </h3>
            {this.state.showPicker && this.rendarcalendar()}
            <button
              className="next-btn"
              onClick={() => this.navigateDate("next", "month")}
            >
              <img src={LeftArrow} />
            </button>
          </div>
        </div>
        <table className="calendar-grid">
          <thead>
            <tr>
              <th>Sun</th>
              <th>Mon</th>
              <th>Tue</th>
              <th>Wed</th>
              <th>Thu</th>
              <th>Fri</th>
              <th>Sat</th>
            </tr>
          </thead>
          <tbody>{this.renderMonthDays()}</tbody>
        </table>
      </div>
    );
  }

  renderMonthDays() {
    const { calendarData } = this.state;
    const weeks = [];
    let currentWeek = [];

    if (!calendarData.month.days || calendarData.month.days.length === 0) {
      return (
        <tr>
          <td colSpan="7" className="empty-month">
            No events scheduled for this month
          </td>
        </tr>
      );
    }

    // const firstDay = new Date(calendarData.month.start_date).getDay();
    const firstDay = this.parseDateWithoutTimezone(
      calendarData.month.start_date,
    ).getDay();

    for (let i = 0; i < firstDay; i++) {
      currentWeek.push(<td key={`empty-${i}`} className="empty-day"></td>);
    }

    calendarData.month.days.forEach((day) => {
      const date = this.parseDateWithoutTimezone(day.date);
      const isToday = date.toDateString() === new Date().toDateString();

      const dayEvents = calendarData.events.filter((event) => {
        const eventStart = event.start_date
          ? this.parseDateWithoutTimezone(event.start_date)
          : null;
        const eventEnd = event.end_date
          ? this.parseDateWithoutTimezone(event.end_date)
          : null;
        const recurrenceEnd = event.recurrence_end_date
          ? this.parseDateWithoutTimezone(event.recurrence_end_date)
          : null;

        const normalizedDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        );
        const normalizedEventStart = eventStart
          ? new Date(
              eventStart.getFullYear(),
              eventStart.getMonth(),
              eventStart.getDate(),
            )
          : null;
        const normalizedEventEnd = eventEnd
          ? new Date(
              eventEnd.getFullYear(),
              eventEnd.getMonth(),
              eventEnd.getDate(),
            )
          : null;
        const normalizedRecurrenceEnd = recurrenceEnd
          ? new Date(
              recurrenceEnd.getFullYear(),
              recurrenceEnd.getMonth(),
              recurrenceEnd.getDate(),
            )
          : null;

        if (normalizedEventStart && normalizedDate < normalizedEventStart) {
          return false;
        }

        if (
          event.recurrence &&
          normalizedRecurrenceEnd &&
          normalizedDate > normalizedRecurrenceEnd
        ) {
          return false;
        }

        switch (parseInt(event.schedule_type)) {
          case 1: // Daily
            return event.recurrence;
          case 2: // Weekly
            return (
              event.recurrence &&
              event.weekday ===
                date.toLocaleDateString("en-US", { weekday: "long" })
            );
          case 4: // Monthly
            return (
              event.recurrence &&
              normalizedEventStart &&
              date.getDate() === normalizedEventStart.getDate()
            );
          case 5: // quarterly
            return (
              event.recurrence &&
              normalizedEventStart &&
              date.getDate() === normalizedEventStart.getDate()
            );
          case 6: // biannually
            return (
              event.recurrence &&
              normalizedEventStart &&
              date.getDate() === normalizedEventStart.getDate()
            );
          case 7: // yearly
            return (
              event.recurrence &&
              normalizedEventStart &&
              date.getDate() === normalizedEventStart.getDate()
            );
          case 3: // Between dates
            return (
              normalizedEventStart &&
              normalizedEventEnd &&
              normalizedDate >= normalizedEventStart &&
              normalizedDate <= normalizedEventEnd
            );
          default: // Single day
            return (
              normalizedEventStart &&
              normalizedEventStart.getTime() === normalizedDate.getTime()
            );
        }
      });

      currentWeek.push(
        <td
          key={day.date}
          className={`calendar-day ${isToday ? "today" : ""}`}
          onClick={() => this.handleDayClick(date)}
        >
          <div className="day-number">{date.getDate()}</div>
          <div className="day-events">
            {dayEvents.slice(0, 2).map((event) => (
              <div
                key={`${event.slug}-${day.date}`}
                className="event-preview"
                style={{ backgroundColor: this.getEventColor(event) }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleEventClick(event);
                }}
              >
                <span className="event-time">
                  <span className="event-part">
                    {Moment(
                      this.parseDateWithoutTimezone(event.start_date),
                    ).format("MMM DD")}
                    , {this.formatTime(event.start_time)}
                  </span>
                  <span className="event-separator"> to </span>
                  <span className="event-part">
                    {Moment(
                      this.parseDateWithoutTimezone(event.end_date),
                    ).format("MMM DD")}
                    , {this.formatTime(event.end_time)}
                  </span>
                </span>{" "}
                <span className="d-block text-truncate">{event.title} </span>
              </div>
            ))}
            {dayEvents.length > 2 && (
              <div
                className="more-events"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleDayClick(date);
                }}
              >
                +{dayEvents.length - 2} more
              </div>
            )}
          </div>
        </td>,
      );

      if (date.getDay() === 6) {
        weeks.push(<tr key={day.date}>{currentWeek}</tr>);
        currentWeek = [];
      }
    });

    if (currentWeek.length > 0) {
      weeks.push(<tr key="last-week">{currentWeek}</tr>);
    }

    return weeks;
  }

  rendarcalendar() {
    if (!this.state.showPicker) return null;
    if (
      this.state.pickerMode === "month" &&
      this.state.isFromDayView == undefined
    ) {
      return (
        <div className="picker-popup" ref={this.pickerRef}>
          <DatePicker
            inline
            showMonthYearPicker
            dateFormat="MMMM"
            selected={this.state.selectedDate}
            renderCustomHeader={({ date, decreaseYear, increaseYear }) => (
              <div
                className="react-datepicker__header react-datepicker-year-header month-custom-header"
                onClick={(e) => {
                  const headerWidth = e.currentTarget.offsetWidth;
                  const clickPosition = e.nativeEvent.offsetX;

                  if (clickPosition < headerWidth / 2) {
                    decreaseYear();
                  } else {
                    increaseYear();
                  }
                }}
              >
                <span
                  className="cursor-pointer"
                  onClick={() => this.setState({ pickerMode: "year" })}
                >
                  {date.getFullYear()}
                </span>
              </div>
            )}
            onChange={(date) => {
              this.navigateSelectedDate(date);
              this.setState({
                selectedDate: date,
                showPicker: false,
              });
            }}
          />
        </div>
      );
    } else if (
      this.state.pickerMode === "month" &&
      this.state.isFromDayView == 1
    ) {
      return (
        <div className="picker-popup" ref={this.pickerRef}>
          <DatePicker
            inline
            showMonthYearPicker
            dateFormat="MMMM"
            selected={this.state.selectedDate}
            renderCustomHeader={({ date, decreaseYear, increaseYear }) => (
              <div
                className="react-datepicker__header react-datepicker-year-header month-custom-header"
                onClick={(e) => {
                  const headerWidth = e.currentTarget.offsetWidth;
                  const clickPosition = e.nativeEvent.offsetX;

                  if (clickPosition < headerWidth / 2) {
                    decreaseYear();
                  } else {
                    increaseYear();
                  }
                }}
              >
                <span
                  className="cursor-pointer"
                  onClick={() => this.setState({ pickerMode: "year" })}
                >
                  {date.getFullYear()}
                </span>
              </div>
            )}
            onChange={(date) => {
              this.setState({
                selectedDate: date,
                showPicker: true,
                pickerMode: "day",
              });
            }}
          />
        </div>
      );
    } else if (this.state.pickerMode === "year") {
      return (
        <div className="picker-popup" ref={this.pickerRef}>
          <DatePicker
            inline
            showYearPicker
            dateFormat="yyyy"
            selected={this.state.selectedDate}
            onChange={(date) =>
              this.setState({ selectedDate: date, pickerMode: "month" })
            }
          />
        </div>
      );
    } else if (this.state.pickerMode === "day") {
      return (
        <div className="picker-popup" ref={this.pickerRef}>
          <DatePicker
            inline
            showMonthPicker
            showMonthDropdown
            showYearDropdown
            scrollableYearDropdown
            dateFormat="MMMM"
            selected={this.state.selectedDate}
            renderCustomHeader={({ date }) => (
              <div
                className="react-datepicker__header react-datepicker-year-header day-custom-header"
                onClick={(e) => {
                  const headerWidth = e.currentTarget.offsetWidth;
                  const clickPosition = e.nativeEvent.offsetX;

                  if (clickPosition < headerWidth / 2) {
                    this.changeMonth(-1);
                  } else {
                    this.changeMonth(1);
                  }
                }}
              >
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    this.setState({ pickerMode: "month", isFromDayView: 1 })
                  }
                >
                  {this.getMonthName(date.getMonth())}
                </span>
              </div>
            )}
            onChange={(date) => {
              this.navigateSelectedDate(date);
              this.setState({
                selectedDate: date,
                showPicker: false,
              });
            }}
          />
        </div>
      );
    }
  }
  getMonthName(monthIndex) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthIndex];
  }
  changeMonth = (delta) => {
    const { selectedDate } = this.state;
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + delta);
    this.setState({ selectedDate: newDate });
  };

  validateForm = () => {
    const { newEvent, selectedProperty } = this.state;
    const errors = {};

    if (!selectedProperty) {
      errors.property = errorLangMessages.property;
    }

    if (!newEvent.title.trim()) {
      errors.title = errorLangMessages.eventTitle;
    }

    const convertTo24Hour = (timeStr) => {
      if (!timeStr) return null;
      timeStr = timeStr.trim().toUpperCase();
      const timePattern = /^(0?[1-9]|1[0-2]):([0-5][0-9])\s?(AM|PM)$/;
      if (!timePattern.test(timeStr)) {
        return null;
      }

      const [time, period] = timeStr.split(/\s+/);
      let [hours, minutes] = time.split(":");
      hours = parseInt(hours, 10);
      minutes = parseInt(minutes, 10);

      if (period === "PM" && hours < 12) {
        hours += 12;
      } else if (period === "AM" && hours === 12) {
        hours = 0;
      }

      return hours * 60 + minutes;
    };

    const startMinutes = convertTo24Hour(newEvent.startTime);
    const endMinutes = convertTo24Hour(newEvent.endTime);

    const startDate = new Date(newEvent.startDate).toDateString();
    const endDate = new Date(newEvent.endDate).toDateString();

    if (!startMinutes) {
      errors.start_time_error = errorLangMessages.timeMessage;
    } else if (!endMinutes) {
      errors.end_time_error = errorLangMessages.timeMessage;
    } else if (startDate === endDate && startMinutes >= endMinutes) {
      errors.time = errorLangMessages.endTimeGtSt;
    }

    if (newEvent.recurrence) {
      if (!newEvent.recurrenceEndDate) {
        errors.recurrenceEndDate = errorLangMessages.recurrenceEndDate;
      }

      if (newEvent.recurrenceType === "weekly" && !newEvent.weekday) {
        errors.weekday = errorLangMessages.weekDayRecurrence;
      }

      if (!newEvent.startDate) {
        errors.startDate = errorLangMessages.startDateRecurrence;
      }
    } else {
      if (!newEvent.startDate) {
        errors.startDate = errorLangMessages.startDate;
      }

      if (!newEvent.endDate) {
        errors.endDate = errorLangMessages.endDate;
      } else if (newEvent.startDate && newEvent.endDate < newEvent.startDate) {
        errors.endDate = errorLangMessages.endDateGtStartDate;
      }
    }

    if (
      newEvent.startDate &&
      newEvent.startDate < new Date().setHours(0, 0, 0, 0)
    ) {
      errors.startDate = errorLangMessages.startDateAlert;
    }

    if (
      newEvent.recurrence &&
      newEvent.recurrenceEndDate &&
      newEvent.startDate &&
      newEvent.recurrenceEndDate < newEvent.startDate
    ) {
      errors.recurrenceEndDate = errorLangMessages.recurrenceEndDateGtStartDate;
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  clearErrors = () => {
    this.setState({ errors: {} });
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
              ? "black"
              : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "gray"
            : state.isFocused && "gray",
        fontFamily: "Roboto-Regular",
        fontSize: "16px",
      }),
    };

    const {
      properties,
      view,
      showEventModal,
      showDayEventsModal,
      selectedDayEvents,
      newEvent,
      editingEventSlug,
      showDeleteConfirm,
      showAlertModal,
      alertModalType,
      alertModalTitle,
      alertModalMessage,
      recurrenceTypes,
    } = this.state;

    return (
      <div>
        <main>
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="brandSection">
                  <div className="dashbaord-pageHeadertitle">
                    <h3 className="flex-column">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <h3>Calendar</h3>
                        <div className="btnNavigate d-flex justify-content-end"></div>
                      </div>
                      <span>Daily Log Events</span>
                    </h3>
                  </div>
                  <div className="event-calendar">
                    <div className="d-flex justify-content-between">
                      <PropertySelection
                        propertySlug={this.getPropertySlug.bind(this)}
                        outSidePropertySlug={this.state.outSidePropertySlug}
                        colClass="col-md-5"
                      />
                      <div className="calendar-header">
                        <div className="view-options">
                          <button
                            onClick={() => {
                              this.changeView("day");
                              this.setState({ showPicker: false });
                            }}
                            className={view === "day" ? "active" : ""}
                          >
                            Day
                          </button>
                          <button
                            onClick={() => {
                              this.changeView("week");
                              this.setState({ showPicker: false });
                            }}
                            className={view === "week" ? "active" : ""}
                          >
                            Week
                          </button>
                          <button
                            onClick={() => {
                              this.changeView("month");
                              this.setState({ showPicker: false });
                            }}
                            className={view === "month" ? "active" : ""}
                          >
                            Month
                          </button>
                        </div>
                        {global.userPermissions.checkPermission(
                          "calendar-add",
                        ) && (
                          <button
                            className="add-event-btn mg-l-7"
                            onClick={this.toggleEventModal}
                          >
                            Add Event
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="calendar-container">
                      <div className="calendar-main">
                        {view === "day" && this.renderDayView()}
                        {view === "week" && this.renderWeekView()}
                        {view === "month" && this.renderMonthView()}
                      </div>
                    </div>

                    {showEventModal && (
                      <div className="modal-overlay">
                        <div className="event-modal">
                          <div className="event-modal-content">
                            <h3>
                              {editingEventSlug
                                ? "Edit Event"
                                : "Add New Event"}
                            </h3>

                            <div className="form-group">
                              <label>Property</label>
                              <Select
                                className={`multiselect new_drop ${
                                  this.state.errors.property
                                    ? "error-border"
                                    : ""
                                }`}
                                menuPlacement="auto"
                                value={this.state.properties.find(
                                  (p) =>
                                    p.value ===
                                    (editingEventSlug
                                      ? newEvent.property_slug
                                      : this.state.selectedProperty?.value),
                                )}
                                options={properties}
                                onChange={this.handleChangeProperty}
                                styles={customStyles}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                              {this.state.errors.property && (
                                <div className="text-danger">
                                  {this.state.errors.property}
                                </div>
                              )}
                            </div>

                            <div className="form-group">
                              <label>Event Title</label>
                              <input
                                type="text"
                                name="title"
                                value={newEvent.title}
                                onChange={this.handleInputChange}
                                className={
                                  this.state.errors.title ? "error-border" : ""
                                }
                                required
                              />
                              {this.state.errors.title && (
                                <div className="text-danger">
                                  {this.state.errors.title}
                                </div>
                              )}
                            </div>

                            <div className="form-group edit-event-checkbox">
                              <label className="check_cust">
                                <input
                                  type="checkbox"
                                  name="recurrence"
                                  checked={newEvent.recurrence}
                                  onChange={this.handleInputChange}
                                />
                                <span className="checkmark"></span>
                                Repeat Event
                              </label>
                            </div>

                            {newEvent.recurrence ? (
                              <>
                                <div className="row">
                                  <div
                                    className={
                                      newEvent.recurrenceType === "weekly"
                                        ? "col-md-6"
                                        : "col-md-12"
                                    }
                                  >
                                    <div className="form-group">
                                      <label>Schedule Type</label>
                                      <Select
                                        className="multiselect new_drop"
                                        menuPlacement="auto"
                                        name="recurrenceType"
                                        value={recurrenceTypes.find(
                                          (p) =>
                                            p.value === newEvent.recurrenceType,
                                        )}
                                        options={recurrenceTypes}
                                        onChange={
                                          this.handleChangeRecurrenceType
                                        }
                                        styles={customStyles}
                                        theme={(theme) => ({
                                          ...theme,
                                          colors: {
                                            ...theme.colors,
                                            primary75: "#808080",
                                            primary50: "#808080",
                                            primary25: "#808080",
                                          },
                                        })}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    {newEvent.recurrenceType === "weekly" && (
                                      <div className="form-group">
                                        <label>Weekday</label>
                                        <Select
                                          className={`multiselect new_drop ${
                                            this.state.errors.weekday
                                              ? "error-border"
                                              : ""
                                          }`}
                                          menuPlacement="auto"
                                          name="weekDay"
                                          value={this.state.weekDay.find(
                                            (p) => p.value === newEvent.weekday,
                                          )}
                                          options={this.state.weekDay}
                                          onChange={this.handleChangeWeekday}
                                          styles={customStyles}
                                          theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                              ...theme.colors,
                                              primary75: "#808080",
                                              primary50: "#808080",
                                              primary25: "#808080",
                                            },
                                          })}
                                        />
                                        {this.state.errors.weekday && (
                                          <div className="text-danger">
                                            {this.state.errors.weekday}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            ) : null}

                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Start Date</label>
                                  <DatePicker
                                    className={`form-control max_width_100 ${
                                      this.state.errors.startDate
                                        ? "error-border"
                                        : ""
                                    }`}
                                    selected={newEvent.startDate}
                                    onChange={(date) =>
                                      this.handleDateChange(date, "startDate")
                                    }
                                    minDate={new Date()}
                                    dateFormat="dd MMM yy"
                                    showMonthDropdown
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={
                                      global.yearDropdownItemNumber
                                    }
                                    required
                                  />
                                  {this.state.errors.startDate && (
                                    <div className="text-danger">
                                      {this.state.errors.startDate}
                                    </div>
                                  )}
                                  {newEvent.recurrenceType == "monthly" ? (
                                    <small>
                                      If any of the selected month has no such
                                      date, the event will not be scheduled for
                                      those particular months.
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Start Time</label>
                                  <InputMask
                                    name="startTime"
                                    onChange={(e) =>
                                      this.handleTimeChange(e, "startTime")
                                    }
                                    value={newEvent.startTime}
                                    mask="99:99 aa"
                                    placeholder="HH:MM AM/PM"
                                    className={
                                      this.state.errors.start_time_error
                                        ? "error-border"
                                        : ""
                                    }
                                  />
                                  {this.state.errors.start_time_error && (
                                    <div className="text-danger">
                                      {this.state.errors.start_time_error}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {newEvent.recurrence ? (
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>End Date</label>
                                    <DatePicker
                                      className={`form-control max_width_100 ${
                                        this.state.errors.recurrenceEndDate
                                          ? "error-border"
                                          : ""
                                      }`}
                                      selected={newEvent.recurrenceEndDate}
                                      onChange={(date) =>
                                        this.handleDateChange(
                                          date,
                                          "recurrenceEndDate",
                                        )
                                      }
                                      minDate={newEvent.startDate || new Date()}
                                      dateFormat="dd MMM yy"
                                      showMonthDropdown
                                      showYearDropdown
                                      scrollableYearDropdown
                                      yearDropdownItemNumber={
                                        global.yearDropdownItemNumber
                                      }
                                      required
                                    />
                                    {this.state.errors.recurrenceEndDate && (
                                      <div className="text-danger">
                                        {this.state.errors.recurrenceEndDate}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>End Date</label>
                                    <DatePicker
                                      className={`form-control max_width_100 ${
                                        this.state.errors.endDate
                                          ? "error-border"
                                          : ""
                                      }`}
                                      selected={newEvent.endDate}
                                      onChange={(date) =>
                                        this.handleDateChange(date, "endDate")
                                      }
                                      minDate={newEvent.startDate || new Date()}
                                      dateFormat="dd MMM yy"
                                      showMonthDropdown
                                      showYearDropdown
                                      scrollableYearDropdown
                                      yearDropdownItemNumber={
                                        global.yearDropdownItemNumber
                                      }
                                      required
                                    />
                                    {this.state.errors.endDate && (
                                      <div className="text-danger">
                                        {this.state.errors.endDate}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>End Time</label>
                                  <InputMask
                                    name="endTime"
                                    onChange={(e) =>
                                      this.handleTimeChange(e, "endTime")
                                    }
                                    value={newEvent.endTime}
                                    mask="99:99 aa"
                                    placeholder="HH:MM AM/PM"
                                    className={
                                      this.state.errors.end_time_error
                                        ? "error-border"
                                        : ""
                                    }
                                  />
                                  {this.state.errors.end_time_error && (
                                    <div className="text-danger">
                                      {this.state.errors.end_time_error}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="form-group">
                              <label>Visibility</label>
                              <Select
                                className="multiselect new_drop"
                                classNamePrefix="multi-event-select"
                                menuPlacement="auto"
                                menuPosition="fixed"
                                name="visibility"
                                menuPortalTarget={document.body}
                                value={this.state.visibility.find(
                                  (p) => p.value === newEvent.visibility,
                                )}
                                options={this.state.visibility}
                                onChange={this.handleChangeVisibility}
                                styles={{
                                  ...customStyles,
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary75: "#808080",
                                    primary50: "#808080",
                                    primary25: "#808080",
                                  },
                                })}
                              />
                            </div>

                            <div className="form-group">
                              <label>Remarks (Optional)</label>
                              <textarea
                                name="remarks"
                                value={newEvent.remarks}
                                onChange={this.handleInputChange}
                              />
                            </div>

                            <div className="modal-actions">
                              <button
                                className="gf-primary-btn-small-one btn btn-primary"
                                onClick={this.handleSaveEvent}
                              >
                                {editingEventSlug ? "Update" : "Save"}
                              </button>
                              <button
                                className="cancel-btn"
                                onClick={this.toggleEventModal}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {showDayEventsModal && (
                      <div
                        className="modal-overlay"
                        onClick={() =>
                          this.setState({ showDayEventsModal: false })
                        }
                      >
                        <div
                          className="day-events-modal"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <h3>
                            {selectedDayEvents.length > 1
                              ? this.formatDateForDisplay(
                                  this.state.monthViewCurrentDate,
                                )
                              : selectedDayEvents[0]?.start_date
                                ? this.formatDateForDisplay(
                                    selectedDayEvents[0].start_date,
                                  )
                                : "Events"}
                          </h3>
                          <div className="events-list">
                            {selectedDayEvents.map((event) => (
                              <div key={event.slug} className="event-item">
                                <div className="event-header">
                                  <strong>
                                    {event?.property?.property_name}
                                  </strong>
                                </div>
                                <p>{event.title}</p>
                                <p className="event-remarks">
                                  <strong>{event.remarks}</strong>
                                </p>
                                <div className="event-details">
                                  {event.schedule_type == 2 && (
                                    <span>Every {event.weekday}</span>
                                  )}
                                  {event.schedule_type == 4 && (
                                    <span>
                                      Monthly on day{" "}
                                      {/* {Moment(this.parseDateWithoutTimezone(event.start_date)).format("DD MMM, YYYY")} */}
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.start_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.start_time)}
                                      </span>
                                      <span className="event-separator">
                                        {" "}
                                        to{" "}
                                      </span>
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.end_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.end_time)}
                                      </span>
                                    </span>
                                  )}
                                  {event.schedule_type == 3 && (
                                    <span>
                                      {/* {Moment(this.parseDateWithoutTimezone(event.start_date)).format("DD MMM, YYYY")}
                                      {' - '}
                                      {Moment(this.parseDateWithoutTimezone(event.end_date)).format("DD MMM, YYYY")} */}
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.start_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.start_time)}
                                      </span>
                                      <span className="event-separator">
                                        {" "}
                                        to{" "}
                                      </span>
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.end_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.end_time)}
                                      </span>
                                    </span>
                                  )}
                                  {event.schedule_type == 5 && (
                                    <span>
                                      {/* {Moment(this.parseDateWithoutTimezone(event.start_date)).format("DD MMM, YYYY")}
                                      {' - '}
                                      {Moment(this.parseDateWithoutTimezone(event.end_date)).format("DD MMM, YYYY")} */}

                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.start_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.start_time)}
                                      </span>
                                      <span className="event-separator">
                                        {" "}
                                        to{" "}
                                      </span>
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.end_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.end_time)}
                                      </span>
                                    </span>
                                  )}
                                  {event.schedule_type == 6 && (
                                    <span>
                                      {/* {Moment(this.parseDateWithoutTimezone(event.start_date)).format("DD MMM, YYYY")}
                                      {' - '}
                                      {Moment(this.parseDateWithoutTimezone(event.end_date)).format("DD MMM, YYYY")} */}

                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.start_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.start_time)}
                                      </span>
                                      <span className="event-separator">
                                        {" "}
                                        to{" "}
                                      </span>
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.end_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.end_time)}
                                      </span>
                                    </span>
                                  )}
                                  {event.schedule_type == 7 && (
                                    <span>
                                      {/* {Moment(this.parseDateWithoutTimezone(event.start_date)).format("DD MMM, YYYY")}
                                      {' - '}
                                      {Moment(this.parseDateWithoutTimezone(event.end_date)).format("DD MMM, YYYY")} */}
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.start_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.start_time)}
                                      </span>
                                      <span className="event-separator">
                                        {" "}
                                        to{" "}
                                      </span>
                                      <span className="event-part">
                                        {Moment(
                                          this.parseDateWithoutTimezone(
                                            event.end_date,
                                          ),
                                        ).format("MMM DD")}
                                        , {this.formatTime(event.end_time)}
                                      </span>
                                    </span>
                                  )}
                                  {event.recurrence_end_date && (
                                    <span className="until-year-text">
                                      Until{" "}
                                      {Moment(
                                        this.parseDateWithoutTimezone(
                                          event.recurrence_end_date,
                                        ),
                                      ).format("DD MMM, YYYY")}
                                    </span>
                                  )}
                                  {/* <span>Visible: {event.visibility}</span> */}
                                </div>
                                <div className="event-meta d-flex align-items-center justify-content-between">
                                  <span
                                    className="event-type"
                                    style={{
                                      backgroundColor:
                                        this.getEventColor(event),
                                    }}
                                  >
                                    {this.getScheduleTypeName(
                                      event.schedule_type,
                                    )}
                                  </span>
                                  <span className="event-time mb-0 p-0 text-capitalize">
                                    Visible: {event.visibility}
                                  </span>
                                  {/* <span className="event-time mb-0 p-0">
                                    {this.formatTime(event.start_time)} -{" "}
                                    {this.formatTime(event.end_time)}
                                  </span> */}
                                </div>
                                <div className="event-actions">
                                  {global.userPermissions.checkPermission(
                                    "calendar-update",
                                  ) && (
                                    <button
                                      className="edit-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.setState({
                                          showDayEventsModal: false,
                                        });
                                        this.handleEditEvent(event);
                                      }}
                                    >
                                      <img src={EditpenIcon} />
                                    </button>
                                  )}
                                  {global.userPermissions.checkPermission(
                                    "calendar-delete",
                                  ) && (
                                    <button
                                      className="delete-btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.setState({
                                          showDayEventsModal: false,
                                        });
                                        this.handleDeleteClick(event);
                                      }}
                                    >
                                      <img src={deleteicon} />
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="text-center">
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.setState({ showDayEventsModal: false })
                              }
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showDeleteConfirm && (
                      <div className="modal-overlay">
                        <div className="delete-confirm-modal">
                          <h3>Confirm Delete</h3>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.deleteEventMessage,
                            }}
                          />
                          <div className="modal-actions">
                            <button
                              className="cancel-btn"
                              onClick={this.cancelDelete}
                            >
                              Cancel
                            </button>
                            <button
                              className="confirm-btn delete-btn"
                              onClick={this.confirmDelete}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {showAlertModal && (
                      <div className="modal-overlay">
                        <div className={`alert-modal ${alertModalType}`}>
                          <h3>{alertModalTitle}</h3>
                          <p>{alertModalMessage}</p>
                          <button
                            className="gf-primary-btn-small-one btn btn-primary mx-auto"
                            onClick={() =>
                              this.setState({ showAlertModal: false })
                            }
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default DailyLogEvent;
